var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8243 8.22157C21.096 7.92999 21.088 7.47561 20.8062 7.19379C20.5244 6.91198 20.07 6.90396 19.7784 7.17566L12.0229 15.0693L4.26747 7.17566C3.97589 6.90396 3.52151 6.91198 3.2397 7.19379C2.95788 7.47561 2.94987 7.92999 3.22157 8.22157L12.0229 17.0229L20.8243 8.22157Z",
    fill: "#160259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.f64235f609a699fb7de57e947740bab0.svg";
export { ForwardRef as ReactComponent };